export default {
    props: {
      source: {
        type: String,
        required: true,
        validator: function (value) {
          return ['youtube', 'vimeo', 'danger'].indexOf(value) !== -1
        }
      },

      videoId: {
        type: String,
        required: true,
      }
    },

    computed: {
      url: function() {
        let value

        switch (this.source) {
          case 'vimeo':
            value = `https://player.vimeo.com/video/${this.videoId}`
            break

          case 'youtube':
          default:
            value = `https://www.youtube.com/embed/${this.videoId}?rel=0`
        }

        return value
      }
    },

    data: function() {
        return {
          display: false,
          width: 560,
          height: 315,
        }
    },

    methods: {
      validateAndDisplay() {
        this.display = (this.videoId.length > 3)
      }
    },

    watch: {
      videoId() {
        this.validateAndDisplay()
      },

      source() {
        this.validateAndDisplay()
      },
    },

    mounted: function() {
      let el = this.$refs.element
      let width = el.getBoundingClientRect().width

      if (width === 0) {
        width = Math.min(window.innerWidth * .9, 720)
      }

      this.width = width
      this.height = Math.ceil(this.width / 16 * 9)

      this.$nextTick(() => {
        this.validateAndDisplay()
      })
    }
}



// WEBPACK FOOTER //
// ./resources/assets/front/js/components/jj-video/script.js